<script setup>
import { ref, computed, onMounted, watch, onBeforeUnmount } from 'vue'
import { Chart, registerables } from 'chart.js'
Chart.register(...registerables)

// props
const props = defineProps({
  title: {
    type: String,
    default: ''
  },
  data: {
    type: Object,
    default: () => ({})
  },
  options: {
    type: Object,
    default: () => ({
      responsive: true,
      maintainAspectRatio: true,
      plugins: {
        legend: {
          display: false,
          position: "bottom",
          align: 'start',
          title: {
            // display: true,
            text: 'Legend Title',
          }
        }
      }
    })
  },
  width: {
    type: Number,
    default: 600
  },
  height: {
    type: Number,
    default: 600
  },
})

// data - ref
const MyChart = ref(null)

// computed
// doughnut chart center text
const chartPlugins = computed(() => {
  const plugins = []
  const innerLabel = {
    id: 'innerLabel',
    afterDatasetDraw(chart, args, pluginOptions) {
      const { ctx } = chart;
      const meta = args.meta;
      const xCoor = meta.data[0].x;
      const yCoor = meta.data[0].y;
      const perc = chart.data.datasets[0].data[0] / meta.total * 100;
      ctx.save();
      ctx.textAlign = 'center';
      ctx.font = `${props.height / 16}px sans-serif`;
      ctx.fillText(perc.toFixed(2) + '%', xCoor, yCoor);
      ctx.restore();
    },
  }

  const dataLabel = {
    id: 'dataLabel',
    afterDatasetDraw(chart, args, pluginOptions) {
      const { ctx } = chart;
      const meta = args.meta;
      meta.data.forEach((data, index) => {
        const x = data.x
        const y = data.y + (data.height / 2)
        const value = `${chart.data.datasets[0].data[index]}억`
        const value2 = `(${chart.data.datasets[0].data[index] / 10}원)`
        ctx.save()
        ctx.textAlign = 'center';
        ctx.font = '16px sans-serif';
        ctx.fillText(value, x, y);
        ctx.fillText(value2, x, y + 20);
        ctx.restore()
      })
    },
  }

  // plugins.push(innerLabel)
  // plugins.push(dataLabel)
  return plugins
})

// watch
watch(() => props.data, (newValue, oldValue) => {
  if (newValue) {
    initChart()
  }
})

// lifecycle
onMounted(() => {
  initChart()
})

onBeforeUnmount(() => {
  Chart.getChart(props.title)?.destroy()
})

// methods
function initChart() {
  if (Chart.getChart(props.title)) {
    Chart.getChart(props.title)?.destroy()
  }
  new Chart(MyChart.value, {
    type: 'line',
    plugins: chartPlugins.value,
    data: props.data,
    options: props.options
  })
}
</script>

<template>
  <article class="canvas-wrap" :style="{ width: `${width}px`, height: `${height}px` }">
    <canvas :id="title" ref="MyChart" />
  </article>
</template>

<style scoped>
.canvas-wrap {
  display: flex;
  justify-content: center;
  align-items: center
}
</style>
